function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearchHistoryRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 25C5.57 25 4 23.43 4 21.5S5.57 18 7.5 18s3.5 1.57 3.5 3.5S9.43 25 7.5 25zm5.5-3.5a5.5 5.5 0 10-11 0 5.5 5.5 0 008.552 4.575L14.477 30 16 28.477l-3.925-3.925A5.474 5.474 0 0013 21.5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2C12.925 2 8 6.925 8 13c0 .347.021.689.052 1.028.728.053 1.426.21 2.081.456A8.96 8.96 0 0110 13c0-4.963 4.037-9 9-9s9 4.037 9 9c0 4.962-4.037 9-9 9a8.934 8.934 0 01-4.023-.961c.009.153.023.305.023.461 0 .574-.07 1.131-.192 1.668C16.1 23.702 17.515 24 19 24c6.075 0 11-4.925 11-11S25.075 2 19 2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8v7h8v-2h-6V8h-2z",
    fill: props.color
  }));
}

export default SvgIconSearchHistoryRexOutline;